// extracted by css-extract-rspack-plugin
module.exports =  {"footer":"DetailsFooter__footer___kgBV4","actions":"DetailsFooter__actions___lTMyj"};